var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/** Isometric projection for 3D surface charts */
export function project3d(x, y, z, cx, cy, scale) {
    if (scale === void 0) { scale = 1; }
    var isoX = (x - y) * Math.cos(Math.PI / 6) * scale;
    var isoY = (x + y) * Math.sin(Math.PI / 6) * scale - z * scale;
    return [cx + isoX, cy + isoY];
}
export function surfaceMeshPath(zGrid, cx, cy, cellSize) {
    var _a, _b;
    if (cellSize === void 0) { cellSize = 8; }
    var paths = [];
    var rows = zGrid.length;
    var cols = (_b = (_a = zGrid[0]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    for (var i = 0; i < rows - 1; i++) {
        for (var j = 0; j < cols - 1; j++) {
            var z00 = zGrid[i][j];
            var z10 = zGrid[i + 1][j];
            var z01 = zGrid[i][j + 1];
            var z11 = zGrid[i + 1][j + 1];
            var _c = __read(project3d(j, i, z00, cx, cy, cellSize), 2), x0 = _c[0], y0 = _c[1];
            var _d = __read(project3d(j + 1, i, z01, cx, cy, cellSize), 2), x1 = _d[0], y1 = _d[1];
            var _e = __read(project3d(j + 1, i + 1, z11, cx, cy, cellSize), 2), x2 = _e[0], y2 = _e[1];
            var _f = __read(project3d(j, i + 1, z10, cx, cy, cellSize), 2), x3 = _f[0], y3 = _f[1];
            paths.push("M ".concat(x0, " ").concat(y0, " L ").concat(x1, " ").concat(y1, " L ").concat(x2, " ").concat(y2, " L ").concat(x3, " ").concat(y3, " Z"));
        }
    }
    return paths;
}
export function wireframePaths(zGrid, cx, cy, cellSize) {
    var _a, _b;
    if (cellSize === void 0) { cellSize = 8; }
    var paths = [];
    var rows = zGrid.length;
    var cols = (_b = (_a = zGrid[0]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    for (var i = 0; i < rows; i++) {
        var d = '';
        for (var j = 0; j < cols; j++) {
            var _c = __read(project3d(j, i, zGrid[i][j], cx, cy, cellSize), 2), x = _c[0], y = _c[1];
            d += (j === 0 ? 'M' : 'L') + " ".concat(x, " ").concat(y);
        }
        paths.push(d);
    }
    for (var j = 0; j < cols; j++) {
        var d = '';
        for (var i = 0; i < rows; i++) {
            var _d = __read(project3d(j, i, zGrid[i][j], cx, cy, cellSize), 2), x = _d[0], y = _d[1];
            d += (i === 0 ? 'M' : 'L') + " ".concat(x, " ").concat(y);
        }
        paths.push(d);
    }
    return paths;
}
export function sampleZGrid(size) {
    if (size === void 0) { size = 8; }
    return Array.from({ length: size }, function (_, i) {
        return Array.from({ length: size }, function (_, j) { return Math.sin(i * 0.5) * Math.cos(j * 0.5) * 3 + 2; });
    });
}
